import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Button } from "../../../components/button";
import { CategoryInput } from "../../categories/components";

interface ISiteForm {
  loading: boolean;
  submit: any;
  form: UseFormReturn<any, any>;
}

export const SiteForm: React.FC<ISiteForm> = ({ loading, submit, form }) => {
  return (
    <div className="card">
      <div className="flex flex-wrap mb-2">
        <div className="w-full mb-2">
          <p className="label">Nom</p>
          <input
            className="w-full input"
            type="text"
            {...form.register("name", { required: "name required" })}
            placeholder="Nom"
          />
        </div>

        <div className="w-full mb-2">
          <p className="label">URL</p>
          <input
            className="w-full input"
            disabled
            type="text"
            {...form.register("url")}
          />
        </div>
        <div className="w-full mb-2">
          <CategoryInput form={form} />
        </div>
        <div className="w-full mb-2">
          <Button
            disabled={!form.formState.isValid}
            loading={loading}
            onClick={submit}
          >
            Valider
          </Button>
        </div>
      </div>
    </div>
  );
};
